"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "graglia": {
    "2851b618": [{
      "hkey": "cceda5e6",
      "slug": "merletto-casale-grippagli-vigna",
      "name": "Merletto-Casale Grippagli-Vigna",
      "primary": true,
      "skipSearch": false
    }],
    "merletto": [{
      "hkey": "cceda5e6",
      "slug": "merletto-casale-grippagli-vigna",
      "name": "Merletto-Casale Grippagli-Vigna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8d4c7b4b": [{
      "hkey": "f09996a7",
      "slug": "santuario-campiglie",
      "name": "Santuario-Campiglie",
      "primary": true,
      "skipSearch": false
    }],
    "santuario": [{
      "hkey": "f09996a7",
      "slug": "santuario-campiglie",
      "name": "Santuario-Campiglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;